module.exports = __webpack_public_path__ + "img/Cheer Megaphone66.e09c58a2.jpg";